export const TEXT_BUTTON_FONT_SIZE = 'text-button-font-size';
